<template>
  <div class="change-co-wrapper">
    <div class="change-co-page">
    <quetions
      v-model="checkedArr"
      ref="chooseQues"
      :quesConfig="quesConfigC"
    ></quetions>
    <div class="cooperation-contact">
  <p class="contact-title">合作联系人 Contact</p>
  <p class="contact-name" style="margin-bottom: 12px;"><img src="@/assets/personicon.png" class="contact-icon" />朱勤超</p>
  
  <p class="contact-phone"><img src="@/assets/mobileicon.png" class="contact-icon" />17625644396</p>
  <p class="contact-email"><img src="@/assets/emailicon.png" class="contact-icon" />zhuqinchao@helloh2.com</p>
</div>
    <div class="change-btns">
      <van-button color="#003df2" @click="submitData" type="primary">
        提交<br/><span class="btn-en">Submi</span>
      </van-button>
      <van-button
        color="#003df2"
        type="primary"
        @click="searchPlace"
        style="margin-left: 20px"
      >
        场地查询<br/><span class="btn-en">Venue Inquiry</span>
      </van-button>
      <van-button
        plain
        type="primary"
        @click="goBack"
        style="margin-left: 20px"
        color="#003df2"
      >
        返回<br/><span class="btn-en">Back</span>
      </van-button>
    </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import quetions from './components/questions-common.vue'
import { quesConfigC } from '@/utils/cForm.js'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import api from '@/api'

const store = useStore()
const router = useRouter()
const mainColor = computed(() => store.state.mainColor)
const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)
const token = computed(() => store.state.token)
const checkedArr = ref([])

const chooseQues = ref(null)
const updatevisitor = () => {
  const params = {    
    exhCode: ExhCode.value,
    VisitorID: VisitorID.value,
    field1: '合作'
  }
  api.updateField(params).then((res) => {
  })
}
const submitData = async () => {
  const chooseRes = chooseQues.value.nextHandler()
  console.log(chooseRes, checkedArr.value, 'kdkdkkd')
  // 问卷验证没有通过不能提交
  if (!chooseRes) return
updatevisitor()
  const res = await api.saveAwsApi({
    VisitorID: VisitorID.value,
    token: token.value,
    ifSubmit: true,
    ExhCode: ExhCode.value,
    QueAndAnswers: checkedArr.value
  })
  if (res.code === 200) {
    router.go(-1)
  }
}
// 场地查询
const searchPlace = () => {
  router.push({ path: '/place' })
}
// 返回
const goBack = () => {
  router.push({ path: '/success' })
}
</script>
<style lang="less" scoped>
.change-co-wrapper {
  padding-top: 20px;
}
/* 合作联系人信息样式 */
.cooperation-contact {
  padding: 16px;
  margin: 16px;
  .contact-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #0020e8;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 18px;
    text-align: left;
  }
  .contact-name,
  .contact-phone,
  .contact-email {
    font-size: 16px;
    color: #646566;
    margin-bottom: 6px;
    line-height: 1.5;
    display: flex;
    align-items: center;
  }
  .contact-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .contact-phone {
    color: #1989fa;
  }
  .contact-email {
    color: #1989fa;
    word-break: break-all;
  }
}
.van-button {
    border-radius: 10px;
  }
</style>
